import Table from"./Table";import{jsx as _jsx}from"react/jsx-runtime";export default function Leaderboard(){return/*#__PURE__*/_jsx(Table,{});}